/**
 * Parst Text-Input fuer replaceList: eine Regel pro Zeile, Format `alt = neu`.
 * Liefert ein Array (Reihenfolge zaehlt, Duplikate sind erlaubt).
 *
 * Whitespace-Behandlung: Es wird nur das Whitespace direkt rund um das `=`-Trennzeichen
 * weggeworfen — fuehrender Whitespace im `from` und abschliessender Whitespace im `to`
 * bleiben erhalten. Damit lassen sich Muster wie ` s GSP` (Leerzeichen vor einer
 * HBF-Abkuerzung, um den Praefix-Trenner mitzufressen) ohne Regex schreiben.
 */
export function parseReplaceRules(text: string): { from: string; to: string }[] {
	const rules: { from: string; to: string }[] = [];
	for (const line of text.split('\n')) {
		const idx = line.indexOf('=');
		if (idx < 0) continue;
		const from = line.substring(0, idx).replace(/\s+$/, '');
		const to = line.substring(idx + 1).replace(/^\s+/, '');
		if (from) rules.push({ from, to });
	}
	return rules;
}
